import React, { useEffect, useState } from "react";
import _axios from "../../../httpService";
import Table from "../../Table";
import CustomeDatePicker from "../../CustomeDatePicker";
import { toast } from "react-toastify";
import TaskViewSection from "./TaskViewSection";
import Swal from "sweetalert2";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import numeric from "../../../utils/NumericFunction";

const GroupPhaseOrders = () => {
  const [showProjectList, setShowProjectList] = useState([]);
  const [showPhaseFilter, setShowPhaseFilter] = useState([]);
  // const [showPhaseSelectOption, setShowPhaseSelectOption] = useState(false);

  const [showEditSection, setShowEditSection] = useState(false);
  const [phaseId, setPhaseId] = useState(0);
  const [showPhaseTasks, setShowPhaseTasks] = useState(false);

  const [select, setSelect] = useState("");
  const [dayValue, setDayValue] = useState("");
  const [startDate, setStartDate] = useState("");

  useEffect(() => {
    // filterData/?
    _axios
      .get(localStorage.getItem("apiUrl") + "/filterData/?filterName=project")
      .then((response) => {
        setShowProjectList(response.data);
        // setShowPhaseFilter(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const onChangeProject = (event) => {
    // setShowPhaseSelectOption(false)
    setShowPhaseTasks(false);
    _axios
      .get(
        localStorage.getItem("apiUrl") +
          "/filterData/?filterName=phase&projectId=" +
          event.target.value
      )
      .then((data) => {
        let tempShowPhaseFilter = data.data;

        setShowPhaseFilter(tempShowPhaseFilter);
        // setShowPhaseSelectOption(true)

        tempShowPhaseFilter.length > 0
          ? setShowEditSection(true)
          : setShowEditSection(false);
      });
  };

  const onChangePhase = (event) => {
    //debugger
    const value = event.target.value;
    showPhaseFilter.length > 0
      ? setShowEditSection(true)
      : setShowEditSection(false);
    setPhaseId(value);
    // setShowPhaseTasks(true)
  };

  function submitForm(event) {
    event.preventDefault();
    console.log(event);
    // const data = event.target.serializeArray();
    // console.log(data);
    if (phaseId === 0) {
      toast.error("فاز انتخاب نشده است.");
      return;
    }
    if (select === "") {
      toast.error("تعلیق یا شیفت؟");
      return;
    }

    if (select === "shift") {
      if (dayValue === "") {
        toast.error("روز های انتخابی معتبر نیست.");
        return;
      }
    }
    if (select === "startDate") {
      if (startDate === "") {
        toast.error("لطفا یک تاریخ انتخاب کنید.");
        return;
      }
      // بریم فرمت تاریخ رو هم چک کنیم ببینیم کاربر یوقتی درستکاری نکرده باشه
      const parts = numeric.p2e(`${startDate}`).split("/");
      //debugger
      if (
        parts.length !== 3 ||
        parts[0].length !== 4 ||
        parts[1].length !== 2 ||
        parts[2].length !== 2
      ) {
        toast.error("لطفا فرمت تاریخ را بررسی کنید.");
        return;
      }
    }
    let coreData = {
      phaseId: `${phaseId}`,
      select: `${select}`,
      days: `${dayValue}`,
      startDate: numeric.p2e(`${startDate}`),
    };
    // formData1.append(`phaseId`, `${phaseId}`)
    // formData1.append(`select`, `${select}`)
    // formData1.append(`days`, `${dayValue}`)

    let formData = {
      project: "saden",
      entity: "VAZAYEF",
      data: coreData,
    };

    console.log(formData);
    //debugger
    // send Request
    _axios
      .post(localStorage.getItem("apiUrl") + "/formFunctionsV2/", formData)
      .then((response) => {
        console.log(response);
        // toast.success("هنوز هیچ در خواستی نداریم 🙄");
        if (response.data.status) {
          Swal.fire({
            icon: "success",
            title: response.data.message,
            showDenyButton: false,
            showCancelButton: false,
            showConfirmButton: true,
          });
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function functionToSetSelect(event) {
    setSelect(event.target.value);
    setDayValue("");
    setStartDate("");
  }

  return (
    <div style={{ maxHeight: "90vh", overflow: "scroll" }}>
      {showProjectList.length > 0 ? (
        <div style={{ margin: "10px auto", width: "300px" }}>
          <div className="form-control0">
            <div style={{}}>
              <select
                onChange={onChangeProject}
                defaultValue={"nullSelect"}
                className="form-select form-select mb-3"
                aria-label=".form-select-lg example"
              >
                <option hidden={true} value={"nullSelect"}>
                  انتخاب پروژه
                </option>
                {showProjectList.map((v, i) => (
                  <option value={v.id}>
                    {v.name} {v.id}{" "}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {showPhaseFilter.length > 0 ? (
            <>
              <div className="form-control0">
                <div style={{}}>
                  <select
                    onChange={onChangePhase}
                    defaultValue={"nullSelect"}
                    className="form-select form-select mb-3"
                    aria-label=".form-select-lg example"
                  >
                    <option hidden={true} value={"nullSelect"}>
                      انتخاب فاز
                    </option>
                    {showPhaseFilter.map((v, i) => (
                      <option value={v.id}>
                        {v.name} {v.id}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </>
          ) : (
            <div
              className={"w-100 text-center rounded-3 border border-gray py-2"}
            >
              <span className={"text-center"}>بدون فاز</span>
            </div>
          )}

          {showEditSection && (
            <div className="position-relative">
              {/*<div className={"bg-primary"} style={{width: "40vw" , margin:"0 auto"}}>*/}

              <form onSubmit={submitForm} className={"my-3"}>
                <div className="form-check0 py-1">
                  <input
                    onChange={functionToSetSelect}
                    name={"phaseOptions"}
                    className="form-check-input"
                    type="radio"
                    value="suspend"
                    id="flexCheckDefault"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexCheckDefault"
                  >
                    تعلیق تسک ها
                  </label>
                </div>
                <div className={"py-1"}>
                  <input
                    onChange={functionToSetSelect}
                    name={"phaseOptions"}
                    className="form-check-input"
                    type="radio"
                    value="shift"
                    id="flexCheckChecked"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexCheckChecked"
                  >
                    شیفت دادن تسک ها
                  </label>
                  {/*<input type={"text"} value={""} placeholder={""}/>*/}
                  {/*<div className="col my-4 text-center">*/}
                  {/*  <div className="form-control">*/}
                  {/*<CustomeDatePicker*/}
                  {/*  className="form-control"*/}
                  {/*  placeholder="تاریخ مورد نظر را وارد کنید..."*/}
                  {/*  name={"endDate"}*/}
                  {/*  calendarPosition="bottom-right"*/}
                  {/*/>*/}
                  {/*</div>*/}
                  {/*</div>*/}
                </div>

                <div className={"py-1"}>
                  <input
                    onChange={functionToSetSelect}
                    name={"phaseOptions"}
                    className="form-check-input"
                    type="radio"
                    value="startDate"
                    id="flexCheckChecked01"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexCheckChecked01"
                  >
                    استارت مجدد تسک های فاز
                  </label>
                  <div className="col my-4 text-center">
                    {select === "shift" ? (
                      <>
                        <div className="input-group input-group-sm mb-3">
                          <input
                            type={"number"}
                            onChange={(event) =>
                              console.log(event.target.value)
                            }
                            className="form-control px-2 py-2"
                            placeholder={"تعداد روز "}
                            onKeyUp={(event) => setDayValue(event.target.value)}
                          />
                        </div>
                      </>
                    ) : select === "startDate" ? (
                      <>
                        <div className="form-control">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            calendar={persian}
                            locale={persian_fa}
                            className="form-control"
                            placeholder="تاریخ"
                            calendarPosition="bottom-right"
                            hideOnScroll
                          />
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>

                  <div className="input-group input-group-sm mb-3">
                    {/*<input*/}
                    {/*  type={"number"}*/}
                    {/*  onChange={(event) => console.log(event.target.value)}*/}
                    {/*  className="form-control" aria-label="Sizing example input"*/}
                    {/*  placeholder={"تعداد روز "}*/}
                    {/*  onKeyUp={(event) => setDayValue(event.target.value)}*/}
                    {/*/>*/}
                  </div>
                </div>
                <div className={"text-center"}>
                  <button type={"submit"} className={"btn btnCustom btnSubmit"}>
                    تایید
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      ) : (
        <></>
      )}

      <div
        style={
          {
            // height: "640px",
            // border: "1px solid #979797",
            // width: " 80vw",
            // overflow: "scroll",
            // borderRadius: "5px",
            // margin:"20px auto",
          }
        }
      >
        {/*<Table id={"466-s"} name={"تسک ها"}/>*/}
        {showPhaseTasks ? (
          <TaskViewSection phaseId={phaseId} />
        ) : (
          <div> . .</div>
        )}
      </div>
    </div>
  );
};

export default GroupPhaseOrders;
